import React from "react";
import MPProductsCarousel from "./MainPageComps/MPProductsCarousel";
import MPImageAd from "./MainPageComps/MPImageAd";
import MPCompaniesCarousel from "./MainPageComps/MPCompaniesCarousel";
import MPNewProductsCarousel from "./MainPageComps/MPNewProductsCarousel";
import MPImageAd2 from "./MainPageComps/MPImageAd2";
import MPNewDubaiProductsCarousel from "./MainPageComps/MPNewDubaiProductsCarousel";
import MPMasterPerfumesCarousel from "./MainPageComps/MPMasterPerfumesCarousel";
import MPDubaiPerfumesCarousel from "./MainPageComps/MPDubaiPerfumesCarousel";

export default function MainPage() {
  return (
    <div>
      <MPImageAd />
      <MPImageAd2 />
      <MPNewDubaiProductsCarousel />
      <MPDubaiPerfumesCarousel />
      <MPMasterPerfumesCarousel />
      {/* <MPNewProductsCarousel /> */}
      {/* <MPProductsCarousel /> */}
      <MPCompaniesCarousel />
      {/* <MPProductsCarousel /> */}
    </div>
  );
}
